const proxyDomain = undefined; // Envs.cloudinary.proxyDomain
export const cloudinaryProxyDomainNormalized = proxyDomain; // proxyDomain?.replace(/\./g, '\\.');
export const CLOUDINARY_ASSETS_DOMAIN = 'res.cloudinary.com';
export const cloudinaryAssetsDomainNormalized = CLOUDINARY_ASSETS_DOMAIN.replace(/\./g, '\\.');
export const cloudinaryCloudRegExp = new RegExp(
	`^(https?://${cloudinaryAssetsDomainNormalized})/([^/]*)/(?:video|image)/upload/([^/]*)/(.*)\\.(.*)`,
	'i',
);
export const cloudinaryProxyRegExp = proxyDomain
	? new RegExp(
			`^(https?://${cloudinaryProxyDomainNormalized})/(?:video|image)/(?:fetch|upload)/([^/]*)/(.*)\\.(.*)`,
			'i',
		)
	: /$^/;
